import { trackFormToQuery as formToQuery } from './trackFormToQuery';
import { trackQueryToForm as queryToForm } from './trackQueryToForm';

export default { queryToForm, formToQuery };
